import DirectionsBoatIcon from "@material-ui/icons/DirectionsBoat";
import { token } from "functions/Helper";
import { CreateRoute } from "views/Route/Create";
import { DeactivateRoute } from "views/Route/Deactivate";
import { DeleteRoute } from "views/Route/Delete";
import { EditRoute } from "views/Route/Edit";
import InActive from "views/Route/InActive";
import InDraft from "views/Route/InDraft";
import { PublishRoute } from "views/Route/Publish";
import Published from "views/Route/Published";
import { ViewRoute } from "views/Route/View";

const route = () => {
  let views = [];

  if (token["master.routes.read"] === "allowed" || token.is_admin === "True") {
    views = views.concat([
      {
        path: "/Route/InDraft",
        name: "InDraft",
        mini: "ID",
        component: InDraft,
        layout: "/admin"
      },
      {
        path: "/Route/Published",
        name: "Published",
        mini: "PU",
        component: Published,
        layout: "/admin"
      },
      {
        path: "/Route/InActive",
        name: "InActive",
        mini: "IA",
        component: InActive,
        layout: "/admin"
      }
    ]);
  }

  if (views.length > 0)
    return [
      {
        collapse: true,
        name: "Route",
        icon: DirectionsBoatIcon,
        state: "RouteCollapse",
        views: views
      }
    ];
  return [];
};

const routeHidden = () => {
  let views = [];

  if (token["master.routes.write"] === "allowed" || token.is_admin === "True") {
    views = views.concat([
      {
        path: "/Route/Create",
        name: "Create Route",
        component: CreateRoute,
        layout: "/admin"
      },
      {
        path: "/Route/Edit",
        name: "Edit Route",
        component: EditRoute,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      },
      {
        path: "/Route/Delete",
        name: "Delete Route",
        component: DeleteRoute,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      }
    ]);
  }

  if (token["master.routes.read"] === "allowed" || token.is_admin === "True") {
    views.push({
      path: "/Route/Detail",
      name: "View Route",
      component: ViewRoute,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });
  }

  if (
    token["master.routes.publish"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/Route/Publish",
      name: "View Route",
      component: PublishRoute,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });
  }

  if (
    token["master.routes.deactivate"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/Route/Deactivate",
      name: "View Route",
      component: DeactivateRoute,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });
  }

  if (views.length > 0)
    return [
      {
        collapse: true,
        name: "Route Hidden",
        state: "routeHidden",
        hideInSidebar: true,
        views: views
      }
    ];
  return [];
};

export { route, routeHidden };
